// Calendar — thin wrapper around react-day-picker v9.
// Uses rdp's built-in stylesheet + a small shadcn-flavoured override
// keyed on CSS variables so the picker inherits our theme.

import * as React from 'react'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'

import { cn } from '@/lib/utils'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({ className, ...props }: CalendarProps) {
  return (
    <DayPicker
      className={cn('rdp-shadcn p-3', className)}
      {...props}
    />
  )
}

export { Calendar }
